import { PanelStatusBarProps } from '@ubnt/link-core-ui/components/BottomPanel/elements/PanelStatusBar';
import { DevicePanelProps } from '@ubnt/link-core-ui/components/BottomPanel/layout/DevicePanel';
import { Flex } from 'components/Flex';
import { useApplicationStore } from 'modules/application/store';
import { ChannelDropdownProps } from '../elements/ChannelDropdown';
import { ChannelUsageSliderProps } from '../elements/ChannelUsageSlider';
import { MCSProps } from '../elements/MCS';
import { MCSChartProps } from '../elements/MCSChart';
import { MLOCheckboxProps } from '../elements/MLOCheckbox';
import { TabsPickerProps } from '../elements/TabsPicker';
import BottomPanelTile from '../layout/BottomPanelTile';

import classes from './WifiPanelResultsDisplay.module.scss';

export interface WifiPanelResultsDisplayProps {
  ChannelDropdown: React.ElementType<Partial<ChannelDropdownProps>>;
  ChannelUsageSlider: React.ElementType<Partial<ChannelUsageSliderProps>>;
  ChannelWidthPicker: React.ElementType<Partial<TabsPickerProps>>;
  MCS: React.ElementType<Partial<MCSProps>>;
  MCSChart: React.ElementType<Partial<MCSChartProps>>;
  AFCCheckbox: React.ElementType<Partial<MLOCheckboxProps>>;
  MLOCheckbox: React.ElementType<Partial<MLOCheckboxProps>>;
  RadioPicker: React.ElementType<Partial<TabsPickerProps>>;
  SignalStatusBar: React.ElementType<Partial<PanelStatusBarProps>>;
  SpeedStatusBar: React.ElementType<Partial<PanelStatusBarProps>>;
  ApDevicePanel?: React.ElementType<Partial<DevicePanelProps>>;
  ClientDevicePanel?: React.ElementType<Partial<DevicePanelProps>>;
}

const WifiPanelResultsDisplay = (props: WifiPanelResultsDisplayProps) => {
  const {
    ChannelDropdown,
    ChannelUsageSlider,
    ChannelWidthPicker,
    MCS,
    MCSChart,
    AFCCheckbox,
    MLOCheckbox,
    RadioPicker,
    SignalStatusBar,
    SpeedStatusBar,
    ApDevicePanel,
    ClientDevicePanel,
  } = props;
  const isMobile = useApplicationStore((state) => state.isMobile);
  const gap = isMobile ? 'l' : 'sCompact';

  return (
    <Flex className={classes.WifiPanelResultsDisplay} gap={gap} column>
      <BottomPanelTile className={classes.realWorldSpeedTile}>
        <SpeedStatusBar className={classes.statusBar} />
      </BottomPanelTile>
      <Flex gap={gap} column={isMobile}>
        <BottomPanelTile className={classes.signalTile}>
          <SignalStatusBar className={classes.statusBar} />
          <MCSChart className={classes.smallBottomMargin} />
          <MCS />
        </BottomPanelTile>
        {!!ApDevicePanel && !!ClientDevicePanel && (
          <Flex gap="l">
            <ApDevicePanel />
            <ClientDevicePanel />
          </Flex>
        )}
        <BottomPanelTile className={classes.channelUsageTile}>
          <ChannelUsageSlider />
        </BottomPanelTile>
      </Flex>
      <Flex gap={gap} column={isMobile}>
        <BottomPanelTile className={classes.radioPickerTile}>
          <RadioPicker className={classes.mediumBottomMargin} />
          <Flex column>
            <AFCCheckbox className={classes.radioCheckbox} />
            <MLOCheckbox className={classes.radioCheckbox} />
          </Flex>
        </BottomPanelTile>
        <BottomPanelTile className={classes.channelWidthTile}>
          <ChannelWidthPicker className={classes.mediumBottomMargin} />
          <ChannelDropdown
            className={classes.channelDropdown}
            portal={!isMobile}
            direction={isMobile ? 'top' : undefined}
          />
        </BottomPanelTile>
      </Flex>
    </Flex>
  );
};

export default WifiPanelResultsDisplay;
